import React from 'react'


import Slider from 'react-slick';

const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <div 
            className={className}
            style={{ 
                // ...style, 
                // right: "155px",
                // width: "40px",
                // height: "45px",
            }} 
            onClick={onClick}
        >
            <img src="/assets/images/white/partner/1.svg" alt="Next" width="40" />
        </div>
    );
};

const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <div 
            className={className}
            style={{ 
                ...style, 
                // left: "135px",
                // width: "40px",
                // height: "45px",
                // zIndex: "10"
            }} 
            onClick={onClick}
        >
            <img src="/assets/images/white/partner/1.svg" alt="Prev" width="40" />
        </div>
    );
};
function PartnersSlider() {

    const settings = {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "60px",
        slidesToShow: 3,
        speed: 500,
        rows: 2,
        slidesPerRow: 2,
         nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
      };

  return (
    <Slider {...settings} className=''>
        <div>
            <img src="/assets/images/white/partner/1.svg" alt="" />
        </div>
        <div>
            <img src="/assets/images/white/partner/2.svg" alt="" />
        </div>
        <div>
            <img src="/assets/images/white/partner/3.svg" alt="" />
        </div>
        <div>
            <img src="/assets/images/white/partner/4.svg" alt="" />
        </div>
        <div>
            <img src="/assets/images/white/partner/5.svg" alt="" />
        </div>
        <div>
            <img src="/assets/images/white/partner/6.svg" alt="" />
        </div>
        <div>
            <img src="/assets/images/white/partner/7.svg" alt="" />
        </div>
        <div>
            <img src="/assets/images/white/partner/8.svg" alt="" />
        </div>
        <div>
            <img src="/assets/images/white/partner/9.svg" alt="" />
        </div>
    </Slider>


    
  )





}

export default PartnersSlider